<template>
  <div id="ty_shouyi" class="relativeItem">
    <!--顶部导航-->
    <topnav
      :vuePage="'#ty_shouyi'"
      :back="1"
      :dark="1"
      :show="1"
      :backcolor="'none'"
      :position="'absolute'"
      :setHeight="0"
    ></topnav>

    <!--头图-->
    <div class="top-img relativeItem">
      <img src="../../assets/tyimg/ty(16).png" class="imgBlock noevents-img" />
      <img src="../../assets/tyimg/ty(46).png" class="imgBlock absoluteItem sign" />
    </div>

    <!--活动规则-->
    <div class="tc gztc" v-show="show_gz">
      <div class="main absoluteItem centerImg">
        <div class="shell relativeItem">
          <img src="../../assets/tyimg/ty(28).png" class="imgBlock noevents-img" />

          <div class="text absoluteItem centerImg">
            <div>
              <p class="indent">
                本次活动仅针对主播资质认证，你可以点击立即分享按钮，分享本次活动给你身边感兴趣的朋友。当你的朋友通过你分享的链接完成了主播资格证的报名缴费等全部操作后，你可以赚取收益，收益可通过“我的分享”中查看明细（注意：未通过你分享的链接完成缴费，无法产生分享收益）。
              </p>
              <p class="indent">
                分享页面的邀请收益会详细记录你的每一次分享收益，你也可以通过分享累计奖励和待提现金额以及可提现金额了解你的分享收益情况。待提现金额会根据通过你分享的链接成功报名缴费人员通过认证流程自动转变为可提现余额，届时你可以通过点击提现按钮提现到你个人的银行卡上面。
              </p>
              <p>提现须知：</p>
              <p class="indent">1.每日提现上限为5000元人民币，超出后无法成功提现</p>
              <p class="indent">2.每日提现次数为1次，超出后无法使用提现功能</p>
              <p class="indent">
                3.申请提现时，请仔细核对您的联系方式确认无误后再提交申请
              </p>
            </div>
          </div>
        </div>
        <span class="close-btn absoluteItem centerX" @click="show_gz = false">
          <img src="../../assets/tyimg/ty(29).png" class="imgBlock noevents-img" />
        </span>
      </div>
    </div>

    <!--主体内容-->
    <div class="content">
      <div class="main">
        <span class="rule" @click="show_gz = true">收益说明</span>
        <div class="num overHidden">
          <div class="flex-box number relativeItem">
            <p class="p1">
              <span class="s1">{{ uinfo.share_money }}</span
              ><span class="s2">我的分享累计奖励（元）</span>
            </p>
            <p class="p2">
              <span class="s1">{{ uinfo.withdrawal_money }}</span
              ><span class="s2">可提现金额（元）</span>
              <span class="s3"
                >待提现金额：<i>{{ uinfo.frozen_money }}</i></span
              >
            </p>
          </div>

          <!--按钮-->
          <div class="btn-shell flex-box">
            <!--分享按钮-->
            <span class="fx-btn" @click="fxqx"></span>
            <!--提现按钮-->
            <span class="tx-btn" @click="show_tx_tc"></span>
          </div>
        </div>

        <!--记录-->
        <div class="record">
          <div class="title flex-box">
            <span :class="{ clicked: ac == 0 }" @click="ac = 0">邀请收益</span>
            <span :class="{ clicked: ac == 1 }" @click="ac = 1">提现记录</span>
          </div>
          <!--标题名称-->
          <div class="title-name flex-box" v-show="ac == 0">
            <span>缴费用户</span>
            <span>分享时间</span>
            <span>分享收益</span>
          </div>
          <div class="title-name flex-box" v-show="ac == 1">
            <span>提现金额</span>
            <span>提现时间</span>
            <span>提现状态</span>
          </div>
          <!--记录列表-->
          <ul class="records share" id="u-fx" v-show="ac == 0">
            <li class="flex-box" v-for="(n, index) in fx_list" :key="index">
              <span class="apostrophe">{{ n.user_name }}</span>
              <span>{{ n.pay_time }}</span>
              <span>{{ n.get_money }}元</span>
            </li>
            <i v-if="fx_list.length == 0">没有相关记录</i>
          </ul>
          <ul class="records money" id="u-tx" v-show="ac == 1">
            <li class="flex-box" v-for="(n, index) in tx_list" :key="index">
              <span>{{ parseInt(n.money) }}元</span>
              <span>{{ n.create_time }}</span>
              <span class="error" v-if="n.status == 0">处理中</span>
              <span class="success" v-else>已到账</span>
            </li>
            <i v-if="tx_list.length == 0">没有相关记录</i>
          </ul>
        </div>
      </div>
    </div>

    <!--提现弹窗-->
    <txtc v-show="show_tx" @closetx="close_tx" :allmoney="allmoney"></txtc>
  </div>
</template>

<script>
import txtc from "./ty_tx";
import topnav from "../index/top_nav";

export default {
  name: "ty_shouyi",
  components: { txtc, topnav },
  data() {
    return {
      show_gz: false,
      show_tx: false, //是否显示提现弹窗
      ac: 0, //记录列表的激活显示下标
      uinfo: {
        frozen_money: "0.00",
        share_money: "0.00",
        withdrawal_money: "0.00",
      }, //用户信息
      allmoney: 0,
      tx_list: [],
      tx_more: true,
      tx_page: 1,
      fx_list: [],
      fx_more: true,
      fx_page: 1,
      scroll_obj:{
        fx:0,//分享记录的滑动加载更多的标识
        tx:0//提现记录的滑动加载更多的标识
      }
    };
  },
  methods: {
    /**显示提现弹窗 */
    show_tx_tc() {
      this.allmoney = this.uinfo.withdrawal_money;
      this.show_tx = true;
    },
    /**关闭提现弹窗 */
    close_tx(data) {
      if (data) {
        //清空本页数据全部重新加载
        this.tx_list = [];
        this.tx_more = true;
        this.tx_page = 1;
        this.get_txjl();
        this.get_yue();
        this.show_tx = false;
      } else {
        this.show_tx = false;
      }
    },

    /**获取用户余额 */
    get_yue() {
      let _this = this;
      let data = {};
      this.$jsonp(this.$apis("ty_yue"), data, (res) => {
        if (res.data.data.length > 0) {
          _this.uinfo = res.data.data[0];
        }
      });
    },

    /**调用分享权限 */
    fxqx() {
      let _this = this;
      this.$jsonp(this.$apis("ty_fxqx"), {}, (res) => {
        if (res.data.data.share_power) {
          _this.oepn_share();
        } else {
          _this.$tool.tip("非法用户");
        }
      });
    },

    /**让app打开分享 */
    oepn_share() {
      let data = {
        title: "主播许可证",
        dec: "购买课程 进阶百万主播",
        url: window.location.origin + "/zshushare",
      };
      this.$appAc.openShare2(data, 0);
    },

    /**请求分享记录 */
    get_fx() {
      let _this = this;
      let data = { page: this.fx_page, pagesize: 8 };
      this.$jsonp(this.$apis("ty_fxjl"), data, (res) => {
        if (res.data.data.length == 0) {
          _this.fx_more = false;
        } else {
          if (_this.fx_page == 1 && _this.scroll_obj.fx == 0) {
            _this.getMore("u-fx");
            _this.scroll_obj.fx = 1;
          }
          let ls = res.data.data;
          ls.forEach((e) => {
            _this.fx_list.push(e);
          });
        }
      });
    },
    /**请求提现记录 */
    get_txjl() {
      let _this = this;
      let data = { page: this.tx_page, pagesize: 8 };
      this.$jsonp(this.$apis("ty_txjl"), data, (res) => {
        if (res.data.data.length == 0) {
          _this.tx_more = false;
        } else {
          if (_this.tx_page == 1 && _this.scroll_obj.tx == 0) {
            _this.getMore("u-tx");
            _this.scroll_obj.tx = 1;
          }
          let ls = res.data.data;
          ls.forEach((e) => {
            _this.tx_list.push(e);
          });
        }
      });
    },

    //下拉加载更多 */
    getMore(id) {
      let _this = this;
      let ownid = id;
      let f = this.$tool.getByID(id);
      let top = f.scrollTop;
      f.addEventListener("scroll", function (e) {
        top = e.target.scrollTop;
        let s = f.scrollHeight - top - f.offsetHeight <= 1;
        if (ownid == "u-tx") {
          if (s && _this.tx_more) {
            _this.tx_page++;
            _this.get_txjl();
          }
        } else {
          if (s && _this.fx_more) {
            _this.fx_page++;
            _this.get_fx();
          }
        }
      });
    },
  },
  mounted: function () {
    this.$tool.setTitle("邀请收益");
    this.get_yue();
    this.get_fx();
    this.get_txjl();
  },
};
</script>

<style scoped>
#ty_shouyi {
  background: url("../../assets/tyimg/ty(4).jpg") left top no-repeat;
  background-size: 100%;
  overflow: hidden;
}
.top-img {
  width: 100%;
  margin: 0 auto;
  margin-top: 10px;
}
.top-img .sign {
  width: 34%;
  top: 30%;
  left: 39%;
}

/**规则 */
.gztc .main {
  width: 94%;
}
.gztc span {
  bottom: -50px;
  width: 9%;
}
.gztc .shell {
  width: 100%;
  background-size: 100%;
}
.gztc .text {
  width: 100%;
  font-size: 10px;
  color: #fdeeb7;
  line-height: 18px;
  text-align: justify;
  height: 100%;
  padding: 0 5%;
}
.gztc .text div {
  margin-top: 28%;
  height: 52%;
  overflow: scroll;
}
.gztc .indent {
  text-indent: 2em;
}

/**主体内容 */
.content {
  position: relative;
  top: -30px;
  max-height: 135vh;
  background-size: 100%;
  width: 100%;
  padding-bottom: 10vh;
  background: none;
  overflow: hidden;
}
.content .main {
  margin: 0 7px;
  border-radius: 15px;
  background: url("../../assets/tyimg/ty(12).png") 0 0 no-repeat;
  background-size: 100%;
  min-height: 45vh;
  margin-top: 20px;
  padding-bottom: 12px;
}
.rule {
  font-size: 10px;
  color: #ff8300;
  float: right;
  padding-left: 13px;
  background: url("../../assets/tyimg/ty(30).png") left center no-repeat;
  background-size: 10px;
  margin-top: 10px;
  margin-right: 7.5%;
  margin-bottom: 10px;
}

/**金额 */
.num {
  clear: both;
  width: 85%;
  background: url("../../assets/tyimg/ty(32).png") left top no-repeat;
  background-size: 100%;
  margin: 0 auto;
  padding-bottom: 18px;
  margin-top: 10px;
}
.num .number {
  margin-top: 4%;
  align-items: center;
}
.num .number::after {
  position: absolute;
  content: "";
  width: 1px;
  height: 100%;
  left: 50%;
  top: 50%;
  transform: translateX(-50%) translateY(-50%);
  background: url("../../assets/tyimg/ty(44).png") left top no-repeat;
  background-size: 100% 100%;
}
.number span {
  display: block;
  color: #fff;
  text-align: center;
}
.number .p1 {
  width: 50%;
}
.number .p2 {
  width: 50%;
}
.number .s1 {
  font-size: 20px;
  font-weight: bold;
}
.number .s2 {
  font-size: 10px;
}
.number .s3 {
  font-size: 10px;
  margin-top: 3px;
  vertical-align: middle;
}
.number i {
  font-style: normal;
  font-size: 13px;
  color: #fff;
  font-weight: bold;
}
.btn-shell {
  width: 60%;
  justify-content: space-between;
  margin: 0 auto;
  margin-top: 5vh;
}
.btn-shell span {
  display: inline-block;
  width: 47%;
  height: 5vh;
}
/* .tx-btn {

} */

/**记录 */
.record {
  min-height: 35vh;
  width: 85%;
  background: url("../../assets/tyimg/ty(31).png") left top no-repeat;
  background-size: 100%;
  margin: 0 auto;
  padding-top: 1.5rem;
}
.title {
  padding: 0 26%;
  justify-content: space-between;
  font-size: 11px;
  color: #666;
  align-items: center;
}
.title .clicked {
  position: relative;
  font-size: 13px;
  font-weight: bold;
  color: #8f54f4;
}
.title .clicked::after {
  position: absolute;
  content: "";
  width: 100%;
  height: 1px;
  border-bottom: 1px solid #8f54f4;
  bottom: -5px;
  left: 0;
}
.title-name {
  border-radius: 5px;
  background: #e5e5e5;
  width: 80%;
  margin: 0 auto;
  justify-content: space-around;
  padding: 6px 0;
  font-size: 11px;
  text-align: center;
  margin-top: 15px;
}
.title-name span,
.records span {
  display: inline-block;
  width: 30%;
}
.records {
  width: 80%;
  margin: 0 auto;
  font-size: 9px;
  text-align: center;
  max-height: 14vh;
  overflow-y: scroll;
  margin-top: 2px;
}
.records li {
  padding: 6px 0;
  justify-content: space-around;
  align-items: center;
}
.records i {
  font-size: 12px;
  color: #666;
  display: block;
  text-align: center;
  font-style: normal;
  margin-top: 38px;
}
.share li span:nth-child(1) {
  text-align: left;
  padding-left: 5%;
}
.money .error {
  color: #ff0000;
}
.money .success {
  color: #6dc31f;
}
</style>
